import React, { useState } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { useSelector } from 'react-redux';
import UploadType from './scenes/UploadType';
import Progress from './components/Progress';
import Files from './scenes/Files';
import Recipient from './scenes/Recipient';
import MainLayout from '../../../../components/Layout/MainLayout';
import s from './Upload.module.sass';
import { MdLock } from 'react-icons/md';
import SecurityModal from './components/SecurityModal';
import { useTranslation } from 'react-i18next';

const CustomerUpload = () => {
  const { t } = useTranslation('upload');
  const userCanUploadFiles = useSelector(state => state.deliveries.userCanUploadFiles);
  
  const [currentStep, setCurrentStep] = useState(0);
  
  const methods = useForm({
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    defaultValues: {
      gdpr: {
        hasPersonalDetails: null,
        origin: '',
        purpose: '',
        noOfEntities: '',
        type: '',
        description: ''
      },
      fileDrop: [],
      recipient: '',
      specificRecipient: false
    }
  });

  const stepNames = [
    { title: t('stepNames1') },
    { title: t('stepNames2') },
    { title: t('stepNames3') }
  ];

  const handleNext = async (data) => {
    
    if (currentStep === 1) {
      const { fileDrop, gdpr } = data;

      methods.clearErrors('fileDrop');
      
      if (!fileDrop || fileDrop.length === 0) {
        methods.setError('fileDrop', {
          type: 'required',
          message: t('files.validate.errorMessage')
        });
        return;
      }

      if (gdpr.hasPersonalDetails) {
        const isValid = await methods.trigger([
          'gdpr.origin',
          'gdpr.purpose',
          'gdpr.noOfEntities',
          'gdpr.type',
          'gdpr.description'
        ]);
        
        if (!isValid) {
          return;
        }
      }
    }
    
    if (currentStep < 2) {
      setCurrentStep(prev => prev + 1);
    }
  };

  const handlePrevious = () => {
    if (currentStep > 0) {
      methods.clearErrors();
      setCurrentStep(prev => prev - 1);
    }
  };

  const renderStep = () => {
    switch (currentStep) {
      case 0:
        return <UploadType onSubmit={handleNext} />;
      case 1:
        return <Files onSubmit={handleNext} previous={handlePrevious} />;
      case 2:
        return <Recipient previous={handlePrevious} />;
      default:
        return null;
    }
  };

  return (
    <FormProvider {...methods}>
      <MainLayout title={t('page-title')} userCanUploadFiles={userCanUploadFiles}>
        <div className={s['customer-upload'] + ' card'}>
          <div className="wizard">
            <Progress stepNames={stepNames} currentStep={currentStep} />
            <div className="step">
              {renderStep()}
            </div>
          </div>
        </div>
        <div className={s['security-message']}>
          <MdLock className={s['security-message__icon']} />
          <div className={s['security-message__text']}>
            {t('securityModal.openModalMessagePartOne')}
            <SecurityModal s={s} />
            {t('securityModal.openModalMessagePartTwo')}
          </div>
        </div>
      </MainLayout>
    </FormProvider>
  );
};

export default CustomerUpload;